import { useEffect, useState } from 'react'

import { Avatar } from 'src/components/atoms/Avatar'
import { Card } from 'src/components/atoms/Card'
import { LoadingSpinner } from 'src/components/atoms/LoadingSpinner'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'
import { PaginationRebrand } from 'src/components/molecules/PaginationRebrand'

import { useGetUserEventViewsForRegistryQuery } from 'src/config/generated/graphql'
import { usePagination } from 'src/hooks/usePagination'
import { formatDate } from 'src/utils/date'

export interface RegistryEventFeedRebrandProps {
  registryId: string
}

export const RegistryEventFeedRebrand = ({
  registryId
}: RegistryEventFeedRebrandProps) => {
  const [queryVariables, setQueryVariables] = useState({ offset: 0 })

  const { data: purchasesData, loading: purchasesLoading } =
    useGetUserEventViewsForRegistryQuery({
      variables: { ...queryVariables, registryId }
    })

  const { currentPage, offset, onPageClick } = usePagination()

  useEffect(() => {
    setQueryVariables({ offset })
  }, [offset])

  return (
    <Card corner='square'>
      <div className='text-center'>
        <TypographyRebrand variant='h4' color='forestDeep'>
          Messages from gifters
        </TypographyRebrand>
      </div>
      <LoadingSpinner isLoading={purchasesLoading}>
        {!purchasesData?.UserEventView.length ? (
          <p className='mt-10 text-center font-body-rebrand text-forestDeep'>
            No messages yet
          </p>
        ) : null}
        {purchasesData?.UserEventView?.map(event => {
          const createdOn = formatDate({
            date: event.CreatedOn!,
            format: 'DD/MM/YYYY [at] hh:MM a',
            isUtc: true
          })

          const name = event.Name?.trim() || 'Someone'
          return (
            <div key={event.Id} className='flex space-x-4 align-middle py-2'>
              <div>
                <Avatar avatar={event.Avatar} name={name} />
              </div>
              <div>
                <TypographyRebrand variant='h5' color='forestDeep'>
                  {name} {event.Description}
                </TypographyRebrand>
                <p className='font-body-rebrand text-sm text-forestDeep/60 mt-1'>
                  {createdOn}
                </p>
                <p className='font-body-rebrand text-forestDeep mt-1'>
                  {event.Comment}
                </p>
              </div>
            </div>
          )
        })}
      </LoadingSpinner>
      <div className='flex justify-center'>
        <PaginationRebrand
          count={purchasesData?.UserEventView_aggregate?.aggregate?.count || 0}
          page={currentPage}
          pageSize={10}
          onChange={onPageClick}
        />
      </div>
    </Card>
  )
}
